var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArreowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7366 18.5217H4.49413C3.81341 18.5227 3.14633 18.3309 2.57011 17.9685C1.99388 17.6061 1.53207 17.0879 1.23812 16.4739C0.894026 15.7454 0.761494 14.9349 0.855629 14.1348C0.949764 13.3346 1.26678 12.577 1.77055 11.9483L10.3918 1.50448C10.7301 1.11411 11.1484 0.801026 11.6183 0.586454C12.0882 0.371883 12.5988 0.260834 13.1154 0.260834C13.6319 0.260834 14.1425 0.371883 14.6124 0.586454C15.0823 0.801026 15.5006 1.11411 15.8389 1.50448L24.4602 11.9483C24.964 12.577 25.281 13.3346 25.3751 14.1348C25.4692 14.9349 25.3367 15.7454 24.9926 16.4739C24.6987 17.0879 24.2369 17.6061 23.6606 17.9685C23.0844 18.3309 22.4173 18.5227 21.7366 18.5217Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArreowIcon);
export default __webpack_public_path__ + "static/media/upArreowIcon.2485d7167fa95c140cfc87927fad9bd5.svg";
export { ForwardRef as ReactComponent };